
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GeneralTab from './components/GeneralTab';
import SecurityTab from './components/SecurityTab';
import ActivityTab from './components/ActivityTab';
import { User, Shield, Activity } from 'lucide-react';

const ProfileSettings = () => {
  const { t } = useTranslation();

  const location = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(() => {
    const hash = location.hash.replace('#', '');
    return hash || 'general';
  });

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash) {
      setActiveTab(hash);
    }
  }, [location.hash]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    navigate(`/profile-settings#${tab}`, { replace: true });
  };

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-foreground">{t('sidebar.profile_settings')}</h1>
        <p className="text-muted-foreground mt-1">{t('profile_settings.subtitle')}</p>
      </div>
      <div className="flex flex-col md:flex-row gap-8">
        {/* Sidebar Tabs */}
        <div className="w-full md:w-64 flex flex-col space-y-1">
          <button
            onClick={() => handleTabChange('general')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
              activeTab === 'general' 
                ? 'bg-primary/10 text-primary' 
                : 'text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            <User size={18} />
            {t('profile_settings.general')}
          </button>
          
          <button
            onClick={() => handleTabChange('security')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
              activeTab === 'security' 
                ? 'bg-primary/10 text-primary' 
                : 'text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            <Shield size={18} />
            {t('profile_settings.security')}
          </button>

          <button
            onClick={() => handleTabChange('activity')}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
              activeTab === 'activity' 
                ? 'bg-primary/10 text-primary' 
                : 'text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            <Activity size={18} />
            {t('profile_settings.activity')}
          </button>
        </div>

        {/* Tab Content */}
        <div className="flex-1">
          {activeTab === 'general' && <GeneralTab />}
          {activeTab === 'security' && <SecurityTab />}
          {activeTab === 'activity' && <ActivityTab />}
        </div>
      </div>
    </div>
  );
};

export default ProfileSettings;
